const styles = ({ BREAKPOINTS }) => ({
  container: {
    margin: '40px 0 0',
    [`@media (min-width: ${BREAKPOINTS.SM})`]: {
      borderLeft: '1px solid #ececec',
      padding: '0 40px 0',
      margin: '0 0 0 30px'
    }
  }
})

export default styles
